import {api} from './api';
import {SHARE_KEY_HEADER_NAME} from '../common/sharedView';
import {TimelineCollectionEntry, TimelineEntry} from '../types';
import {TimelineRecordMetaDto} from './timelineRecordMeta';
import {SharedRepositorySourceDto} from './sharedCollections';

export interface SharedTimelineResponseDto {
	timeline: TimelineEntry;
	collections: TimelineCollectionEntry[];
	/** One per collection plotted on the timeline. */
	sources: SharedRepositorySourceDto[];
	meta: TimelineRecordMetaDto[];
}

/** Read-only timeline behind a share link, authorized by the share key alone. */
export const sharedTimelinesApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSharedTimeline: builder.query<SharedTimelineResponseDto, {shareKey: string; includeArchived: boolean}>({
			query: ({shareKey, includeArchived}) => ({
				url: 'shared/timeline',
				params: {includeArchived},
				headers: {[SHARE_KEY_HEADER_NAME]: shareKey},
			}),
			extraOptions: {maxRetries: 0},
		}),
	}),
});

export const {
	useGetSharedTimelineQuery,
} = sharedTimelinesApi;
